export const VERIFICA_BOASVINDAS_REQUEST = 'VERIFICA_BOASVINDAS_REQUEST';
export const VERIFICA_BOASVINDAS_SUCCESS = 'VERIFICA_BOASVINDAS_SUCCESS';
export const INSERE_BOASVINDAS_REQUEST = 'INSERE_BOASVINDAS_REQUEST';
export const INSERE_BOASVINDAS_SUCCESS = 'INSERE_BOASVINDAS_SUCCESS';
export const RESET_BOASVINDAS = 'RESET_BOASVINDAS';
